import { render, staticRenderFns } from "./PodrAddEditIn.vue?vue&type=template&id=5469820a&scoped=true&"
import script from "./PodrAddEditIn.vue?vue&type=script&lang=js&"
export * from "./PodrAddEditIn.vue?vue&type=script&lang=js&"
import style0 from "./PodrAddEditIn.vue?vue&type=style&index=0&id=5469820a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5469820a",
  null
  
)

export default component.exports